var render = function () {
  var _ref;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container,
    on: {
      "click": function click($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('div', {
    class: _vm.$style.flag
  }, [_c('country-flag', {
    attrs: {
      "language-code": _vm.languageCode
    }
  })], 1), _c('div', {
    class: [_vm.$style.arrow, (_ref = {}, _ref[_vm.$style.invertedColor] = _vm.invertedColor, _ref)]
  }, [_vm.isShownLanguages ? _c('chevron-up-icon') : _c('chevron-down-icon')], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }